import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-536cda71"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "root" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "titleText" }
const _hoisted_4 = { class: "descText" }

import { computed, onMounted, ref } from 'vue';
import i18n from '@/i18n';
import { getAppIcon } from '../../../utils/RegionAssets';


export default /*#__PURE__*/_defineComponent({
  __name: 'Template-000',
  setup(__props) {

const title = ref('');
const desc = ref('');
const mainImg = computed(() => getAppIcon());

onMounted(() => {
  title.value = i18n.global.t('template.title');
  desc.value = i18n.global.t('template.desc');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("img", {
        class: "mainImg",
        src: mainImg.value
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("p", _hoisted_3, _toDisplayString(title.value), 1),
    _createElementVNode("p", _hoisted_4, _toDisplayString(desc.value), 1)
  ]))
}
}

})